import { miniProgramEnv, platform } from '@/defines/environment'
import { Bridge } from '@mc/mc-jsbridge'
import { isMallApp } from '@mc/mc-base-env/src/web/platform'
import { nativeRedirect } from '../native_redirect'

import { nativeRoutes } from '../native_redirect/routes'
import Url from '@mc/mc-utils/js/url/url'
import { cmsPreviewKey, passportId } from '@/defines/user'

const transformMApp = url => {
  const [main, hash] = url.split('#')
  const [path, query] = main.split('?')
  let newPath = path
  if (
    platform === 'ios' ||
    platform === 'android' ||
    miniProgramEnv.isMiniProgram
  ) {
    newPath = path.replace('/entry/', '/mapp/main/')
  } else {
    newPath = path.replace('/mapp/main/', '/entry/')
  }
  return `${newPath}${query ? '?' + query : ''}${hash ? '#' + hash : ''}`
}

export const h5Redirect = (url, { transformMAppUrl = true } = {}) => {
  if (url.h5) url = url.h5

  if (url.indexOf('mall://') > 0) {
    return
  }
  if (transformMAppUrl) {
    url = transformMApp(url)
  }
  const urlObj = new Url(url)
  if (cmsPreviewKey) {
    url = urlObj.appendQuery({
      cms_preview_key: cmsPreviewKey,
      passport_id: passportId
    })
  }
  if (miniProgramEnv.isMiniProgram) {
    nativeRedirect(nativeRoutes.webview, {
      url
    })
  } else if (isMallApp()) {
    Bridge.navigateTo(url)
  } else {
    window.location.href = url
  }
}
